import Notice from "@components/complete/Notice/template";

function Complete() {
  return <Notice />;
}

export default Complete;
